export default __webpack_public_path__ + "static/custom-logo-wide-e42978ac5d88c8b266bd3c8a83a1bcd0dc23e624148180c5677a2527e37cc5ce.png";